import { render, staticRenderFns } from "./old-member.vue?vue&type=template&id=0e3d3e94&scoped=true&"
import script from "./old-member.vue?vue&type=script&lang=js&"
export * from "./old-member.vue?vue&type=script&lang=js&"
import style0 from "./old-member.vue?vue&type=style&index=0&id=0e3d3e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3d3e94",
  null
  
)

export default component.exports